<template>
  <div class="addlog">
    <drag-modal :visible="$store.state.Stages.visible" @cancel="reset" :title='title' width='568px' :class='{"editbox":$route.params.id}'>
      <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{span: 4}" :wrapper-col="{span: 20}">
        <a-row class="clearbox">
          <a-col :span='12'>
            <a-form-model-item label="履行时间" prop='time' :rules="{ required: true, message: '请选择履行时间',trigger: 'change'}" :label-col="{span: 8}" :wrapper-col="{span: 12}">
              <a-date-picker v-model="form.time" placeholder="请选择" style="width: 145px;" valueFormat="YYYY-MM-DD" :disabled='Type==0' />
            </a-form-model-item>
          </a-col>
          <a-col :span='12'>
            <a-form-model-item label="履行金额" prop='fee' :rules="{ required: true, message: '请输入履行金额',trigger: 'change'}" :label-col="{span: 8}" :wrapper-col="{span: 12}">
              <a-input-number v-model="form.fee" style="width:145px;" placeholder="请输入履行金额" :class='{"yellow":form.audit}' :disabled="form.audit || Type==0" disabled />
            </a-form-model-item>
          </a-col>
        </a-row>
        <div class="dform">
          <div class='h2'>履行构成</div>
          <div class="overboes">
            <div class="inputli" v-for='(i,index) in form.list' :key='index'>
              <a-form-model-item :label="i.label" :label-col="{span: 8}" :wrapper-col="{span: 20}" style="margin:0;">
                <a-input-number v-model="i.fee" style="width:210px;" :min='0' placeholder="请输入" :class='{"yellow":i.audit}' :disabled="i.audit || Type==0" @blur="allmoney" />
              </a-form-model-item>
            </div>
          </div>
        </div>
        <a-form-model-item :wrapper-col="{ span: 24 }" v-if='Type!=0' style="text-align:center;">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm(Type)">
            <a-button type="primary" style="width:148px;">
              提交
            </a-button>
          </a-popconfirm>
          <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
  </div>
</template>
<script>
import stepCredit from "./step.json"
const Credit = stepCredit.map(ele => {
  return ({
    fee: '',
    type: ele.type,
    label: ele.tit
  })
})
// function swapArray(arr, index1, index2) {
//   arr[index1] = arr.splice(index2, 1, arr[index1])[0];
//   return arr;
// }
// swapArray(Credit, 7, 0)
// swapArray(Credit, 8, 1)
// swapArray(Credit, 7, 2)
export default {
  props: {
    Type: {
      type: Number,
      default() {
        return 0      //0 查看 1修改  2新增
      }
    }
  },
  computed: {
    title() {
      return ["查看分期信息", "修改分期信息", "新增分期信息"][this.Type]
    }
  },
  data() {
    return {
      type: 0,
      rules: {},
      visible: false,
      form: {
        time: '',
        fee: '',
        list: JSON.parse(JSON.stringify(Credit))
      }
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.Type == 1) {
        let list = JSON.parse(JSON.stringify(Credit))

        let Stages = JSON.parse(JSON.stringify(this.$store.state.Stages.cur))
        list.map(element => {
          Stages.list.map(ele => {
            if (element.type == ele.type) {
              element.fee = ele.fee <= 0 ? '' : ele.fee
              element.audit = ele.audit
              element.id = ele.id || 0
            }
          })
        })
        this.$set(this.form, "audit", Stages.audit)
        this.$set(this.form, "id", Stages.id || 0)
        this.$set(this.form, "time", Stages.time)
        this.$set(this.form, "fee", Stages.fee)
        this.$set(this.form, "list", list)
      }
    })
  },
  methods: {

    allmoney() {
      const fee = this.form.list.map(ele => {
        return ele.fee || 0
      }).reduce(function (prev, curr, idx, arr) {
        return prev + curr;
      });
      this.form.fee = (fee).toFixed(2)
    },
    confirm(Type) {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          for (let val in form) {
            form.list.map(ele => {
              ele.type = ele.type * 1
              ele.id = ele.id || 0
              delete ele.label
            })
          }
          let list = form.list.filter(ele => {
            return ele.fee > 0
          })
          if (list.length == 0) {
            this.$message.error({ content: '履行构成不能为空', key: 'updatable' });
            return false;
          }
          const allmoney = list.map(ele => {
            return ele.fee
          }).reduce(function (prev, curr, idx, arr) {
            return prev + curr;
          });
          if ((allmoney).toFixed(2) != form.fee) {
            this.$message.error({ content: '履行构成各项相加应当等于履行金额', key: 'updatable' });
            return false;
          }

          if (!form.id) {
            form.id = 0
          }
          form.list = list;
          if (Type == 1) {      //修改
            let stages = this.$store.state.Stages;
            let curIndex = stages.curIndex
            let nlist = JSON.parse(JSON.stringify(stages.list))
            nlist[curIndex] = form;
            this.$store.dispatch('Stages/setInfokey', { key: 'list', value: nlist })
          } else {
            this.$store.dispatch('Stages/add', form)
          }
          this.reset()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      this.form.list = JSON.parse(JSON.stringify(Credit));
      this.$refs.forms.resetFields();
      this.$store.dispatch('Stages/setInfokey', { key: 'visible', value: false })
    }
  }
}
</script>
<style lang="less">
.dform {
  .ant-form-item-label {
    text-align: left;
  }
}
</style>
<style lang="less" scoped>
.dform {
  padding: 0 16px;
  margin-top: -10px;
  .overboes {
    overflow: hidden;
    margin-bottom: 40px;
  }
  .h2 {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
  }
}
.inputli {
  width: 50%;
  float: left;
  &:nth-child(even) {
    padding-left: 20px;
  }
}
</style>